module.exports = __webpack_public_path__ + "img/currency-guide-1.a5462320.jpg";